import React, { useRef } from "react";
import { Button, Input, Spinner } from "@public/ui-toolkit";
import { useFormik } from "formik";
import * as Yup from "yup";

const FCNQuery = ({ loading, onSubmitNewPostHandler, message }) => {
  const messageRef = useRef("");
  const subjectRef = useRef("");

  const formik = useFormik({
    initialValues: {
      subject: "",
      message: "",
    },
    validationSchema: Yup.object({
      subject: Yup.string().required("Subject is Required."),
      message: Yup.string().required("Message is Required"),
    }),
    onSubmit: (values) => {
      onSubmitNewPostHandler(values);
      formik.resetForm();
    },
  });

  return (
    <main>
      <div className="main-inner">
        <div className="container mt-5">
          {loading ? (
            <Spinner />
          ) : (
            <div className="p-xxl-5 p-md-4 p-3 box-shadow bg-white rounded-large">
              <div className="text-center box-lg">
                <h4 className="stylish-title text-blue mb-5">
                  Contact FCN Admin
                </h4>
                <form onSubmit={formik.handleSubmit}>
                  <div className="row g-4">
                    <div className="col-12">
                      <div className="form-floating">
                        <Input
                          type="text"
                          placeholder="Subject"
                          id="subject"
                          label="Subject"
                          inputRef={subjectRef}
                          {...formik.getFieldProps("subject")}
                          props
                        />
                        {formik.touched.subject && formik.errors.subject ? (
                          <div className="form-error-message  pt-4">
                            {formik.errors.subject}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          id="message"
                          placeholder="Message"
                          rows="6"
                          onChange={(e) => e.target.value}
                          {...formik.getFieldProps("message")}
                          ref={messageRef}
                        ></textarea>
                        <label for="description">Message</label>
                        {formik.touched.message && formik.errors.message ? (
                          <div className="form-error-message pt-4">
                            {formik.errors.message}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 text-center">
                    <Button
                      btnName="Submit"
                      btnType="primary"
                      type="submit"
                      loading={loading}
                    />
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default FCNQuery;
